export const apiBaseUrl = "https://proback.perla-tech.com/api";
export const apiBaseAssets = "https://proback.perla-tech.com/";

// export const apiBaseUrl = "http://localhost:9210/api";
// export const apiBaseAssets = "http://localhost:9210/";
